export default __webpack_public_path__ + "static/7-fit-4ee570c150cc4d5140374fc769812682.png";